// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home {
  
  margin: auto;
  width: 100%;
  border: 0px;
  padding: 10px;
  background-color: aliceblue;
  padding-bottom: 40px;
}
.Home h1 {
  font-size: 20px;
  text-align: center;
  background: linear-gradient(to right, #30CFD0 0%, #332288 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.Home .subtext {
  margin: 20px 0px 40px 0px;
  text-align: center;
  font-size: 14px;
  padding-left: 60px;
  padding-right: 30px;
  
}
.Home .p-mr-2 {
  padding-left: 20px;
}
.Home p {
  font-size: 12px;
  color: #607D8B;
}

.Home .p-card-title {
  color: #607D8B;
}`, "",{"version":3,"sources":["webpack://./src/scene-d/Home/Home.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;;AAErB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".Home {\n  \n  margin: auto;\n  width: 100%;\n  border: 0px;\n  padding: 10px;\n  background-color: aliceblue;\n  padding-bottom: 40px;\n}\n.Home h1 {\n  font-size: 20px;\n  text-align: center;\n  background: linear-gradient(to right, #30CFD0 0%, #332288 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.Home .subtext {\n  margin: 20px 0px 40px 0px;\n  text-align: center;\n  font-size: 14px;\n  padding-left: 60px;\n  padding-right: 30px;\n  \n}\n.Home .p-mr-2 {\n  padding-left: 20px;\n}\n.Home p {\n  font-size: 12px;\n  color: #607D8B;\n}\n\n.Home .p-card-title {\n  color: #607D8B;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
